/* eslint-disable react/require-default-props */
import React from 'react';
import pkg from 'prop-types';
import classNames from 'classnames/bind';
import { Typography } from '@one-thd/sui-atomic-components';
import { Carousel } from '@one-thd/sui-carousel';
import styles from './cap-card-section.module.scss';

const cx = classNames.bind(styles);

const CapabilityCardSection = ({
  anchorId = null,
  children = null,
  isCarousel = false,
  isAutoplay = false,
  title = null,
  slidesXs = 1,
  slidesSm = null,
  slidesMd = null,
  slidesLg = null,
  slidesXl = null,
  spaceBetweenXs = 0,
  spaceBetweenSm = 16,
  spaceBetweenMd = 16,
  spaceBetweenLg = 16,
  spaceBetweenXl = 16
}) => {

  const sectionTitle = (
    <>
      {title && (
        <div className={cx('sui-pb-4')}>
          <Typography variant="h2" weight="display" height="snug" color="primary" uppercase>{title}</Typography>
        </div>
      )}
    </>
  );

  const carouselContainer = (contents) => (
    <Carousel
      autoplay={isAutoplay}
      peek={false}
      slidesPerGroup={slidesXs}
      slidesPerView={slidesXs}
      spaceBetween={spaceBetweenXs}
      breakpoints={{
        sm: {
          slidesPerView: slidesSm || 1,
          slidesPerGroup: slidesSm || 1,
          spaceBetween: spaceBetweenSm
        },
        md: {
          slidesPerView: slidesMd || 1,
          slidesPerGroup: slidesMd || 1,
          spaceBetween: spaceBetweenMd
        },
        lg: {
          slidesPerView: slidesLg || 1,
          slidesPerGroup: slidesLg || 1,
          spaceBetween: spaceBetweenLg
        },
        xl: {
          slidesPerView: slidesXl || 1,
          slidesPerGroup: slidesXl || 1,
          spaceBetween: spaceBetweenXl
        }
      }}
    >
      {contents.length >= 1 && contents.map((content, index) => (
        <div
          key={content.id || `content-${index}`}
          className={cx('content-section__carousel', 'sui-w-full', 'sui-bg-primary', 'sui-flex', 'sui-flex-col')}
        >
          {content}
        </div>
      ))}
    </Carousel>
  );

  const contentCols = () => {
    if (children?.length >= 4) {
      return 'content-section__large-container';
    }
    return 'content-section__container';
  };

  return (
    <div id={anchorId}>
      {sectionTitle}
      {isCarousel ? <>{carouselContainer(children)}</>
        : (
          <div>
            {children?.length >= 4 && (
              <div className={cx('content-section__mobile_carousel')}>
                <>{carouselContainer(children)}</>
              </div>
            )}
            <div className={cx('sui-grid', 'sui-gap-4', `${contentCols()}`)}>
              {children}
            </div>
          </div>
        )}
    </div>
  );
};

CapabilityCardSection.propTypes = {
  children: pkg.oneOfType([pkg.node, pkg.arrayOf(pkg.node)]),
  anchorId: pkg.string,
  isCarousel: pkg.bool,
  spaceBetweenXs: pkg.number,
  spaceBetweenSm: pkg.number,
  spaceBetweenMd: pkg.number,
  spaceBetweenLg: pkg.number,
  spaceBetweenXl: pkg.number,
  isAutoplay: pkg.bool,
  title: pkg.string,
  slidesXs: pkg.number,
  slidesSm: pkg.number,
  slidesMd: pkg.number,
  slidesLg: pkg.number,
  slidesXl: pkg.number
};

export { CapabilityCardSection };
